import { create, StoreApi, UseBoundStore } from 'zustand'

interface NotificationStoreState {
  unreadCount: number
  isLoadingUnreadCount: boolean
}

interface NotificationStoreActions {
  setUnreadCount: (_unreadCount: number) => void
  incrementUnreadCount: () => void
  decrementUnreadCount: () => void
  setIsLoadingUnreadCount: (_isLoading: boolean) => void
  reset: () => void
}

type NotificationStore = NotificationStoreState & NotificationStoreActions

const initialState: NotificationStoreState = {
  unreadCount: 0,
  isLoadingUnreadCount: false,
}

const useNotificationStore: UseBoundStore<StoreApi<NotificationStore>> = create((set) => ({
  ...initialState,

  setUnreadCount: (newUnreadCount: number) => {
    set((state) => ({
      ...state,
      unreadCount: newUnreadCount,
    }))
  },

  incrementUnreadCount: () => {
    set((state) => ({
      ...state,
      unreadCount: state.unreadCount + 1,
    }))
  },

  decrementUnreadCount: () => {
    set((state) => ({
      ...state,
      unreadCount: Math.max(0, state.unreadCount - 1),
    }))
  },

  setIsLoadingUnreadCount: (isLoading: boolean) => {
    set((state) => ({
      ...state,
      isLoadingUnreadCount: isLoading,
    }))
  },

  reset: () => {
    set(initialState)
  },
}))

export { useNotificationStore }
